import React, { Component } from "react";
import { Image, Loader } from 'semantic-ui-react';
//zoom support
import 'react-viewer/dist/index.css';
import Viewer from 'react-viewer';
//
import { obtainGetURL } from '../api/fireDepartmentAPI';
//
export default class AsyncImage extends Component {
  constructor(props) {
    super(props);
    this.state = {isLoading: true, hashedFileName: this.props.fileName, signedURL: null, zoomImage: false};
  }
  componentDidMount() { this.startLoading(); }
  //
  startLoading() {
    this._getImageURL(this.state.hashedFileName, urlObject => {
      if (urlObject == null) return;
      this.loadImage(urlObject);
    })
  }
  //
  loadImage(urlObject){
    this.setState({...this.state, signedURL: urlObject});
  }
  stopLoading() {
    this.setState({...this.state, isLoading: false});
  }
  //actions
  handleImageZoom() {
    if (this.state.signedURL != null && !this.state.isLoading && !this.state.zoomImage) {
      this.setState({...this.state, zoomImage : true});
    }
  }
  handleDownload(e) { window.open(this.state.signedURL); }
  //UI
  render() {
    return(
      <div key={this.state.hashedFileName} onClick={this.handleImageZoom.bind(this)}>
          {this.state.signedURL &&
            <Image rounded={true} size={this.props.size}
                   src={this.state.signedURL} onLoad={this.stopLoading.bind(this)}/>}
          {this.state.isLoading &&
            <Loader active size='medium'/>
          }
          { this.state.signedURL && !this.state.isLoading &&
            <Viewer visible={this.state.zoomImage} noImgDetails={true} noFooter={false} changeable={false} noNavbar={true}
                    onClose={() => { this.setState({ zoomImage: false }); } } images={[{src: this.state.signedURL}]}
                    customToolbar={(toolbars) => {
                        return toolbars.concat([{
                            key: 'download-self', render: <div className="react-viewer-icon react-viewer-icon-download"></div>,
                            onClick: this.handleDownload.bind(this)
                          }]);
                        }}
             />
          }
      </div>
    );
  }


  //private
  async _getImageURL(imageID, callback) {
    try {
      const urlObject = await obtainGetURL(imageID);
      callback(urlObject);
    } catch (error) {
      console.log(error);
      callback(null);
    }
  }
}
